import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withCookies } from 'react-cookie';
import { connect } from 'react-redux';
import uniqueId from 'lodash/uniqueId';

import {
  ExtendedFlex,
  Heading,
  ExtendedBox,
  VisibilitySensor,
  StyledButton,
} from '../../coreui';

import salesforceActions from '../../salesforce/actions';

import FadeIn from '../../components/FadeIn';
import DynamicBrowseJoinLink from '../../helpers';

import heroBannerImage from '../../assets/HP_hero_LA.jpg';
import HeroTextInput from '../../components/HeroTextInput';

export const redirectToUserRegister = (history) => {
  history.push('/user/register');
};

class Hero extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isVisible: false,
      email: '',
      formSubmitted: false,
    };

    this.id = uniqueId('salesforceWebToLeadSubmission-');

    this.handleSensorChange = this.handleSensorChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.state.formSubmitted
        && this.props.success !== prevProps.success
        && this.props.id === this.id) {
      redirectToUserRegister(this.props.history);
    }
  }

  handleSensorChange(isVisible) {
    if (isVisible) {
      this.setState({
        isVisible,
      });
    }
  }

  handleEmailChange({ target: { value: email } }) {
    this.setState({ email });
    this.props.cookies.set(
      'rm_captured_email',
      email, {
        maxAge: 3600,
      },
    );
  }

  handleClick() {
    if (!this.state.formSubmitted) {
      this.submitForm();
    }
  }

  handleKeyDown({
    key,
    target,
  }) {
    if (key === 'Enter') {
      target.blur();
      if (!this.state.formSubmitted) {
        this.submitForm();
      }
    }
  }

  submitForm() {
    this.setState({
      formSubmitted: true,
    });

    // If an email wasn't set, there's no need to POST the form.
    if (!this.state.email) {
      redirectToUserRegister(this.props.history);
      return;
    }

    // Attempt to POST the form.
    this.props.postWebToSalesforceRequested({
      id: this.id,
      data: {
        email: this.state.email,
        recordType: '0120f000001NTSZ',
      },
    });
  }

  render() {
    const { isVisible, email } = this.state;
    const { isLoggedIn } = this.props;

    return (
      <ExtendedBox
        bgImage={heroBannerImage}
        bgSize="cover"
        bgRepeat="no-repeat"
        bgPosition="center center"
        height="100vh"
      >
        <ExtendedFlex
          justify="center"
          height="100%"
          align="center"
          flexDirection="column"
          px={20}
        >
          <FadeIn>
            <Heading
              type="H1"
              color="white"
              mb={20}
              opacity={isVisible ? '1' : '0'}
              textAlign="center"
            >
              Invest in Real Estate
            </Heading>
            <Heading
              type="H5"
              color="white"
              display="block"
              maxWidth="100%"
              textAlign="center"
              mt={0}
              mb={20}
              textTransform="uppercase"
              opacity={isVisible ? '1' : '0'}
            >
              Build the future you want
            </Heading>
          </FadeIn>
          <VisibilitySensor
            callback={this.handleSensorChange}
          />
          <FadeIn
            fadeInIndex={3}
          >
            <Heading
              type="H6"
              color="white"
              display="block"
              maxWidth="100%"
              textAlign="center"
              mt={0}
              mb={[40, 40, 100, 100, 100]}
              opacity={isVisible ? '1' : '0'}
            >
              Access Institutional Quality Investments
            </Heading>
            <ExtendedFlex
              mb={[60, 60, 120, 120, 120]}
              opacity={isVisible ? '1' : '0'}
              flexDirection={['column', null, null, 'row']}
              align="center"
              justify="center"
            >
              {
                !isLoggedIn &&
                <>
                  <HeroTextInput
                    placeholder="Enter Email Address"
                    value={email}
                    onChange={this.handleEmailChange}
                    onKeyDown={this.handleKeyDown}
                    data-test="email-input-banner"
                  />
                  <StyledButton
                    type="L1"
                    onClick={this.handleClick}
                    loading={this.state.formSubmitted}
                    data-test="join-now-banner"
                  >
                    Join Now
                  </StyledButton>
                </>
              }
              {
                isLoggedIn &&
                <DynamicBrowseJoinLink
                  isLoggedIn={isLoggedIn}
                  type="L1"
                />
              }
            </ExtendedFlex>
          </FadeIn>
        </ExtendedFlex>
      </ExtendedBox>
    );
  }
}

const mapStateToProps = (state) => ({
  id: state.salesforce.id,
  success: state.salesforce.success,
});

const mapDispatchToProps = (dispatch) => ({
  postWebToSalesforceRequested: (data) => {
    dispatch(salesforceActions.postWebToSalesforceRequested(data));
  },
});

Hero.propTypes = {
  isLoggedIn: PropTypes.bool,
  postWebToSalesforceRequested: PropTypes.func,
  id: PropTypes.string,
  success: PropTypes.bool,
  history: PropTypes.object,
  cookies: PropTypes.object,
};

export default withCookies(withRouter(connect(mapStateToProps, mapDispatchToProps)(Hero)));
